<style lang="scss">

</style>

<template>
  <!-- eslint-disable -->
  <div class="post-search-page mb-4">

    <section class="d-flex full-width justify-content-end">
      <b-button @click="$bvModal.show('modal-add-keyword')" class="btn-success" cy="add-keyword">Add Keyword or Phrase</b-button>
    </section>

    <section class="my-2">
      <h4>Filters</h4>

      <div class="row">
        <section class="col-3">
          <label>{{'prisoner' | term(true)}} Number</label>
          <b-form-input
            cy="prisoner-number-input"
            @keyup.enter="searchKeywords()"
            v-model="filters.prisonerNumber"
            class="mb-1" :placeholder="'Enter ' + $options.filters.term('prisoner') + ' number'"
          />
        </section>

        <section class="col-3">
          <label>Sort</label>
          <b-form-select @change="searchKeywords()" v-model="filters.sort" class="mb-1">
            <b-form-select-option value="updated_at">Updated (Oldest First)</b-form-select-option>
            <b-form-select-option value="-updated_at">Updated (Newest First)</b-form-select-option>
            <b-form-select-option value="keyword">Keyword (A-Z)</b-form-select-option>
            <b-form-select-option value="-keyword">Keyword (Z-A)</b-form-select-option>
            <b-form-select-option value="prisoner_number">{{ $options.filters.term('prisoner') | capEachWord }} Number (A-Z)</b-form-select-option>
            <b-form-select-option value="-prisoner_number">{{ $options.filters.term('prisoner') | capEachWord }} Number (Z-A)</b-form-select-option>
          </b-form-select>
        </section>

        <section class="col-3 align-items-center d-flex" style="margin-top: 5px">
          <b-button cy="clear-btn" @click="clearFilters()">Clear filters</b-button>
          <b-button cy="search-btn" class="btn-success ml-1" @click="searchKeywords()">Search</b-button>
        </section>
      </div>
    </section>

    <b-card no-body class="mb-0">
      <section>
        <b-table
          class="data-table"
          hover
          :items="keywords"
          :fields="headers"
          :current-page="currentPage"
          :per-page="null"
        >
          <template #cell(prisoner_number)="data">
            {{data.item.prisoner_number || '-'}}
          </template>

          <template #cell(updated_at)="data">
            {{data.item.updated_at | formatDateTime}}
          </template>
          <template #cell(created_at)="data">
            {{data.item.created_at | formatDateTime}}
          </template>
          <template #cell(actions)="data">
            <b-dropdown class="m-0"  variant="link" right toggle-class="text-decoration-none" no-caret>
              <template #button-content>
                <i class="fas fa-ellipsis-v"></i>
              </template>
              <b-dropdown-item-button class="full-nested-btn"
                                      @click="showKeywordModal(data.item, 'modal-update-keyword')">
                Update
              </b-dropdown-item-button>
              <b-dropdown-item-button class="full-nested-btn"
                                      @click="showKeywordModal(data.item, 'modal-delete-keyword')">
                Delete
              </b-dropdown-item-button>
            </b-dropdown>
          </template>
        </b-table>
        <b-row class="p-1">
          <b-col md="6" class="m-1" v-if="totalRows > filters.limit">
            <b-pagination @change="getKeywords()" :total-rows="totalRows" :per-page="filters.limit" v-model="currentPage" class="my-0"/>
          </b-col>
          <p v-if="totalRows === 0" class="col-6 ml-2 my-1">No records</p>
        </b-row>
      </section>
    </b-card>

    <b-modal id="modal-add-keyword" title="Add new keyword or phrase" hide-footer>
      <add-keyword @refresh="getKeywords()" @close="closeModals()"></add-keyword>
    </b-modal>

    <b-modal id="modal-update-keyword" title="Update keyword or phrase" hide-footer>
      <update-keyword v-if="selectedKeyword" :existing-keyword="selectedKeyword" @refresh="getKeywords()" @close="closeModals()"></update-keyword>
    </b-modal>

    <b-modal id="modal-delete-keyword" title="Delete keyword or phrase" hide-footer>
      <delete-modal v-if="selectedKeyword" @close="closeModals()" @delete="deleteKeyword(selectedKeyword)"
                    :subtitle="selectedKeyword.keyword"
                    title="Are you sure you wish to delete"></delete-modal>
    </b-modal>
  </div>
  <!-- eslint-enable -->
</template>

<script>
  import HelperService from '../../services/HelperService';
  import KeywordsService from '../../services/KeywordsService';
  import DeleteModal from '../../components/modals/DeleteModal.vue';
  import AddKeyword from './sections/AddKeyword.vue';
  import UpdateKeyword from './sections/UpdateKeyword.vue';

  export default {
    name: 'KeywordSearch',
    components: {
      DeleteModal,
      AddKeyword,
      UpdateKeyword,
    },
    data() {
      return {
        helperService: new HelperService(),
        loading: true,
        selectedKeyword: null,
        headers: [
          { label: 'Keyword', key: 'keyword' },
          { label: 'Keyword Type', key: 'keywordType' },
          { label: 'Match Type', key: 'match_type' },
          { label: `${this.$options.filters.term('prisoner')} Number`, key: 'prisoner_number' },
          { label: 'Created', key: 'created_at' },
          { label: 'Updated', key: 'updated_at' },
          { label: '', key: 'actions' },
        ],
        keywords: [],
        currentPage: 1,
        totalRows: 10,
        filters: {
          prisonerNumber: '',
          skip: 1,
          sort: '-updated_at',
          limit: 10,
        },
      };
    },
    computed: {},
    watch: {
      currentPage() {
        this.getKeywords();
      },
      $route() {
        this.setUp();
      },
    },
    mounted() {
      this.setUp();
    },
    methods: {
      setUp() {
        this.getKeywords();
      },
      searchKeywords() {
        this.currentPage = 1;

        this.getKeywords();
      },
      closeModals() {
        this.$bvModal.hide('modal-add-keyword');
        this.$bvModal.hide('modal-update-keyword');
        this.$bvModal.hide('modal-delete-keyword');
      },
      getKeywords() {
        this.filters.skip = (this.currentPage - 1) * this.filters.limit;
        this.closeModals();

        KeywordsService.getAllKeywords(this.filters).then(res => {
          this.loading = false;
          this.keywords = res.data.data;
          this.totalRows = res.data.count;
        }).catch(err => {
          console.log('Error getting keywords ', err);
          this.$toast.error('Could not get keywords, please refresh and try again', {
            toastClassName: ['toast-std', 'warning-toast'],
          });
        });
      },
      clearFilters() {
        this.filters = {
          prisonerNumber: '',
          skip: 1,
        };

        this.searchKeywords();
      },
      setSelectedKeyword(keyword) {
        this.selectedKeyword = keyword;
      },
      showKeywordModal(keyword, modalName) {
        this.setSelectedKeyword(keyword);
        this.$bvModal.show(modalName);
      },
      deleteKeyword(keyword) {
        // eslint-disable-next-line no-underscore-dangle
        KeywordsService.deleteKeyword(keyword._id).then(() => {
          this.$toast.success(`Deleted keyword ${keyword.keyword} Successfully`, {
            toastClassName: ['toast-std', 'success-toast'],
          });

          this.getKeywords();
        }).catch(err => {
          console.log('error deleting keyword', err);
          this.$toast.error('Could not delete keyword, please refresh and try again', {
            toastClassName: ['toast-std', 'warning-toast'],
          });
        });
      },
    },
  };
</script>
